import {
  Box,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { TechnicianPosition } from '../../../utils/entities/type';
import { FormChangeEvent } from './technicianModal';
import { ProfessionalSkill } from '../../../utils/entities/interface';

interface ProfessionalFormProps {
  professionalSkills: ProfessionalSkill[];
  position: TechnicianPosition;
  experience: string;
  onSkillChange: (
    acType: string,
    field: keyof Omit<ProfessionalSkill, 'acType'>,
    value: boolean,
  ) => void;
  handleChange: (e: FormChangeEvent) => void;
}

export const ProfessionalForm: React.FC<ProfessionalFormProps> = ({
  professionalSkills,
  onSkillChange,
  handleChange,
  position,
  experience,
}) => {
  return (
    <Box sx={{ color: 'white' }}>
      {/* Headers */}
      <Grid
        container
        spacing={2}
        justifyContent={'space-between'}
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item xs={6}>
          <Typography gutterBottom>
            Position of Technician
          </Typography>
          <Select
            name="position"
            value={position}
            onChange={handleChange}
            fullWidth
            sx={{
              backgroundColor: '#222',
              borderRadius: '8px',
              color: '#fff',
            }}
          >
            <MenuItem value="TBA">Not Assigned (TBA)</MenuItem>
            <MenuItem value="HELPER">Helper</MenuItem>
            <MenuItem value="TECHNICIAN">Technician</MenuItem>
            <MenuItem value="SENIOR TECHNICIAN">Senior Technician</MenuItem>
            <MenuItem value="SUPERVISOR">Supervisor</MenuItem>
            <MenuItem value="MANAGER">Manager</MenuItem>
          </Select>
        </Grid>{' '}
        <Grid item xs={6} lg={6} md={6}>
          <Typography gutterBottom>
            Experience
          </Typography>
          <TextField
            name="exp"
            value={experience}
            onChange={handleChange}
            fullWidth
            sx={{
              backgroundColor: '#222',
              borderRadius: '8px',
              color: '#fff',
            }}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography fontWeight="bold">AC Type</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography align="center">S</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography align="center">R</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography align="center">I</Typography>
        </Grid>
      </Grid>

      {/* Rows */}
      {professionalSkills.map((skill, index) => (
        <Grid
          container
          spacing={2}
          alignItems="center"
          key={index}
          sx={{ mb: 1 }}
          justifyContent={'space-between'}
        >
          <Grid item xs={8}>
            <Typography>{skill.acType}</Typography>
          </Grid>
          <Grid item xs={1} textAlign="center">
            <Checkbox
              checked={skill.service}
              onChange={(e) =>
                onSkillChange(skill.acType, 'service', e.target.checked)
              }
            />
          </Grid>
          <Grid item xs={1} textAlign="center">
            <Checkbox
              checked={skill.repair}
              onChange={(e) =>
                onSkillChange(skill.acType, 'repair', e.target.checked)
              }
            />
          </Grid>
          <Grid item xs={1} textAlign="center">
            <Checkbox
              checked={skill.install}
              onChange={(e) =>
                onSkillChange(skill.acType, 'install', e.target.checked)
              }
            />
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};
